import { Box } from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import { qk } from 'api'
import { getLanguagesList } from 'api/languages'

export const CountryFlag = ({
  languageCode,
  size,
}: {
  languageCode: string
  size: number
}) => {
  const { data: languages } = useQuery(
    qk.languages.list.toKey(),
    getLanguagesList,
  )

  if (!languages) return null

  const currentLanguageCountryFlag = languages.find(
    language => language.code === languageCode,
  )?.image

  return (
    <Box
      component="img"
      src={currentLanguageCountryFlag}
      display="block"
      width={size}
      height={size}
      border="1px solid white"
      borderRadius="12px"
    />
  )
}
